export default __webpack_public_path__ + "static/media/wave.4541d846.png";